export const confirmation = (context, message, title = "Confirmar") => {
    return context.$swal({
        title: title,
        text: message,
        icon: "warning",
        buttons: true,
        dangerMode: true,
    });
};

const swalCustom = (context, message, title, icon) => {
    if (!title) {
        switch (icon) {
            case 'success':
                title = 'Correcto'
                break;
            case 'warning':
                title = 'Atención'
                break;
            case 'info':
                title = 'Información'
                break;
            case 'error':
                title = 'Error'
                break;
        }
    }
    context.$swal({
        title: title,
        text: message,
        icon: icon,
    });
}

export const swal = (context, message, title) => {
    return {
        success: () => {
            swalCustom(context, message, title, 'success')
        },
        warning: () => {
            swalCustom(context, message, title, 'warning')
        },
        info: () => {
            swalCustom(context, message, title, 'info')
        },
        error: () => {
            swalCustom(context, message, title, 'error')
        },
    }
}

export const validArray = (array, minLength = 0) => {
    return Array.isArray(array) && array.length >= minLength;
};

export const sortByKeyName = (list, keyName) => {
    return list.sort(function (a, b) {
        if (a[keyName] < b[keyName]) {
            return -1;
        }
        if (a[keyName] > b[keyName]) {
            return 1;
        }
        return 0;
    });
};

export const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const getUrlParameters = (url = window.location.search) => {
    var parameters = url.replace(/\?/g, '').split("&");
    var finalParameters = {};
    for (var i = 0; i < parameters.length; i++) {
        var parts = parameters[i].split("=");
        var key = decodeURIComponent(parts[0]);
        var value = decodeURIComponent(parts[1]);
        if (typeof finalParameters[key] === "undefined") {
            finalParameters[key] = decodeURIComponent(value);
        } else if (typeof finalParameters[key] === "string") {
            var groupValues = [finalParameters[key], decodeURIComponent(value)];
            finalParameters[key] = groupValues;
        } else {
            finalParameters[key].push(decodeURIComponent(value));
        }
    }
    return finalParameters;
}
/**
 *  Dependiendo del nombre de la propiedad se renderiza las propiedades del
 *  icono del  total
 * @param text nombre de la propiedad del objeto
 * @returns {string} titulo del total
 */
export const renderPropsTotals = (text) => {

    const mappings = {
        'totalizedAdjust': {
            title: 'Ajuste Parqueadero',
            icon: 'mdi-chart-timeline',
            color: 'text-info'
        },
        'totalizedParking': {
            title: 'Servicio parqueadero',
            icon: 'mdi-parking',
            color: 'text-info'
        },
        'totalizedLost': {
            title: 'Comprobantes perdidos',
            icon: 'mdi-nfc-variant',
            color: 'text-info'
        },
        'totalizedProduct': {
            title: 'Productos o miscelaneos',
            icon: 'mdi-store',
            color: 'text-success'
        },
        'totalizedMonthly': {
            title: 'Servicio de Abonados',
            icon: 'mdi-calendar',
            color: 'text-info'
        },
        'totalizedSubtotal': {
            title: 'Subtotal facturado',
            icon: 'mdi-cash-multiple',
            color: 'text-success'
        },
        'totalizedTax': {
            title: 'Impuesto facturación',
            icon: 'mdi-shuffle-variant',
            color: 'text-primary'
        },
        'totalizedCash': {
            title: 'Total pago en efectivo',
            icon: 'mdi-cash',
            color: 'text-success'
        },
        'totalizaedElectronic': {
            title: 'Total pagos electrónicos',
            icon: 'mdi-credit-card-multiple',
            color: 'text-info'
        },
        'totalizedTotal': {
            title: 'Total ventas',
            icon: 'mdi-shuffle-variant',
            color: 'text-primary'
        }
    };
    return mappings[text] || null;

}
export const formatPrice = (num) => {
    const options = {style: 'currency', currency: 'COP', minimumFractionDigits: 0};
    const format = new Intl.NumberFormat('es-CO', options);
    return format.format(num);
}
export const formatPriceTwo = (num) => {
    // Convertir el número a una cadena con tres decimales
    const numString = num.toFixed(3);

    // Eliminar los ceros adicionales después de los tres decimales
    const formattedNum = numString.replace(/\.?0*$/, '');
    const options = {style: 'currency', currency: 'COP', minimumFractionDigits: formattedNum.includes('.') ? 3 : 0};
    const format = new Intl.NumberFormat('es-CO', options);
    return format.format(num);
}
export const getFileUrlData = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", callback);
    reader.readAsDataURL(file);
}

export const capitalizeFirstLetter = (text) => {
    const arrayText = text.toLowerCase().split(" ");
    text = "";
    arrayText.forEach(item => {
        const newItem = item.trim();
        if (newItem.length > 0) {
            text += newItem[0].toUpperCase() + newItem.substring(1) + ' ';
        }
    });
    return text.trim();
}

export const validateExtension = (fileName) => {
    let allowedExtension = ["jpg", "png"];
    const arrayExtension = fileName.split(".");
    const nameExtension = arrayExtension[arrayExtension.length - 1];
    let validateBoolean = false;
    for (const record of allowedExtension) {
        if (nameExtension == record) {
            validateBoolean = true;
            break;
        }
    }
    return validateBoolean;
}
/**
 * Verifica que el número ingresado sea mayor o igual al recibido del minNumber
 * @param text
 * @param minNumber
 * @returns {boolean}
 */
export const isGreaterThan = (text, minNumber) => {
    const regex = new RegExp(`^([${minNumber}-9]\\d*)?$`);
    return regex.test(text);
}

export const clear = (info) => {
    for (const key in info) {
        info[key] = null;
    }
}



